export interface StatusMessageResponse {
    status: boolean
    message: string
}